import styled from "styled-components"

export const ActionSection = styled.section`
  background: #ccffff;
  border: solid 1px grey;
  & a {
    min-width: 100px;
    display: inline-block;
    padding: 2px 8px;
    text-align: center;
    box-sizing: border-box;
    text-decoration: none;
    &:first-of-type {
      border-right: solid 1px grey;
    }
  }
`

export const Section = styled.section`
  background: white;
  border: solid 2px rgb(197, 197, 197);
  margin-top: 24px;
  display: inline-block;
  width: 100%;
  max-width: 634px;
  box-sizing: border-box;
  overflow-x: auto;
`

export const Row = styled.div`
  border-bottom: solid 1px rgb(197, 197, 197);
  padding: 6px;
  &.pink {
    background: pink;
  }
`

export const TableWrap = styled.div`
  overflow-x: auto;
  width: 100%;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  th {
    text-align: center;
    background: pink;
    border: solid 1px rgb(197, 197, 197);
    padding: 6px;
  }
  td {
    border: solid 1px rgb(197, 197, 197);
    padding: 6px;
  }
  tr {
    &.yellow {
      background: #ffffe0;
    }
    &.blue {
      background: #e0ffff;
    }
    &.red {
      background: #ffe0ff;
    }
  }
`

export const ListWrap = styled.div`
  overflow-x: auto;
  width: 100%;
  max-width: 634px;
`

export const Header = styled.header`
  background: #999999;
  margin-top: 24px;
  padding: 2px;
  box-sizing: border-box;
`

export const List = styled.div`
  border: solid 1px #999999;
  & section {
    display: flex;
  }
  & section > div {
    text-align: center;
    background: #ccffcc;
    width: 100%;
    border: solid 1px #999999;
    padding: 2px;
  }
  & section > div:nth-of-type(2n) {
    background: #ccffff;
  }
  & section > span {
    width: 314px;
    background: #ffffff;
    text-align: center;
    border: solid 1px #999999;
  }
  & footer {
    background: #ffffff;
    border: solid 1px #999999;
    &.succeed {
      background: #ccff99;
      & .red {
        font-size: 24px;
        color: red;
      }
    }
    & .action-row {
      background: #ccff99;
      display: flex;
      border-top: solid 2px #999999;
      padding: 2px;
      text-align: right;
      & > div {
        width: 25%;
        &.large {
          width: 50%;
        }
        &:not(:last-of-type) {
          border-right: solid 2px #999999;
        }
      }
      & .link {
        color: -webkit-link;
        cursor: pointer;
      }
    }
    & .highlight {
      font-size: 24px;
      color: red;
      font-weight: bold;
      padding: 2px;
    }
    & .action {
      width: calc(50% - 1px);
      text-align: center;
      display: inline-block;
      border-top: solid 2px #999999;
      background: #ccff99;
      &:not(:last-of-type) {
        border-right: solid 2px #999999;
        background: #ccffcc;
      }
      & span {
        color: -webkit-link;
        cursor: pointer;
      }
    }
  }
`
